import React, { createContext} from "react";

  const CountWishlistCartContext = createContext();
  export default CountWishlistCartContext;